var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconZoneSchwarz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.81 31.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg4993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10371",
    d: "M14.4,0A8.88,8.88,0,0,0,5.59,8.68c0,4.1,4.71,12.82,6.65,16.28C5.32,25.2,0,26.54,0,28.16,0,30,6.44,31.41,14.4,31.41S28.81,30,28.81,28.16c0-1.63-5.36-3-12.32-3.2,2.79-5.53,6.71-12.83,6.71-16.28A8.88,8.88,0,0,0,14.4,0Zm0,2.36A6.26,6.26,0,1,1,8.14,8.62,6.27,6.27,0,0,1,14.4,2.36Zm0,1.93a4.33,4.33,0,1,0,4.35,4.33A4.33,4.33,0,0,0,14.4,4.29ZM12.66,25.71c.16.28.49.91.52,1,.21.39.61,1.49,1.22,1.69.6-.2,1-1.3,1.23-1.69l.48-1c4,.18,7,1,7,1.93s-3.9,2-8.7,2-8.69-.89-8.69-2S8.7,25.9,12.66,25.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoneSchwarz);
export default __webpack_public_path__ + "static/media/icon_zone_schwarz.47b0c2f31e67af548c9118e797dbf15d.svg";
export { ForwardRef as ReactComponent };